<template>
  <div class="fire-alarm-page">
    <!--主页面 -->
    <div class="flex-row" v-loading="restLoading" element-loading-text="数据处理中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left flex-valign" style="z-index: 2">
        <FireAlarmList ref="alarmList" :alarmData="cacheAlarmList" :listType="listType" v-loading="canvasLoading" element-loading-text="数据绘制中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" @rightClick="handRightClick" @typeChange="handTypeChange" @clickAlarm="alarmItemClick" @handleNodeClick="handleNodeClick" @handleActiveChange="handleActiveChange" @showOperationData2="showOperationData2" @restDevice="restDevice" @searchBtnTypeLever="handleSearchTypeLever" @searchBtn="handleSearchBtn" @resetError="resetError" @handleAlarmControl="handalarmControl" @searchDeviceName="handleSearchDeviceName" @searchAlarmTime="handleSearchAlarmTime" @restBtn="handleRestBtn" @nextPage="loadMoreAlarm"></FireAlarmList>
        <!-- <alarmList
          v-else
          ref="alarmList"
          :data="cacheAlarmList"
          :listType="listType"
          v-loading="canvasLoading"
          element-loading-text="数据绘制中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          @rightClick="handRightClick"
          @typeChange="handTypeChange"
          @clickAlarm="alarmItemClick"
          @showOperationData2="showOperationData2"
          @restDevice="restDevice"
          @searchBtnTypeLever="handleSearchTypeLever"
          @searchBtn="handleSearchBtn"
          @resetError="resetError"
          @handleAlarmControl="handalarmControl"
          @searchDeviceName="handleSearchDeviceName"
          @searchAlarmTime="handleSearchAlarmTime"
          @restBtn="handleRestBtn"
          @nextPage="loadMoreAlarm"
        ></alarmList> -->
      </div>
      <!-- 右侧图纸 -->
      <div class="section-mian_right">
        <div style="position: absolute; z-index: 9999;">
          <el-button type="primary" @click="handleDealShow" v-show="!dealVisible">一键误报</el-button>
        </div>
        <div class="canvasMain">
          <div class="canvasMainT" :style="{
            width: vW + '%',
            height: vH + '%',
            marginTop: getMarginTop + 'px',
            marginLeft: getMarinLeft + 'px',
          }">
            <img class="louceng-img" v-if="hasDrawing" :src="!drawingSrc
              ? '/images/theme/newDark/default-drawing1.jpg'
              : $utils.Bus.imgPath(drawingSrc)
              " />
            <!-- /images/theme/newDark/default-drawing1.jpg -->
            <!-- :src="$utils.Bus.imgPath(drawingSrc)" /> -->
            <!-- 动态图层 -->
            <canvas id="mycanvas" :width="cW" :height="cH"></canvas>
            <!-- 静态图层 -->
            <canvas id="mycanvas2" @mousewheel="mouseScroll" @DOMMouseScroll="mouseScroll" @mousedown="handleDomMoveStart" :width="cW" :height="cH"></canvas>
          </div>
        </div>
        <div class="marTip">
          <div>【 放大比例 {{ vW }}% 】</div>
        </div>
        <div v-if="!hasDrawing" class="no-drawing">暂无楼层图纸</div>
      </div>
      <alarm-details ref="details" :alarmDetail="alarmDetail" :rowClick="rowClickInfo" :workerOrderList="workerOrderList" :buildingPerson="buildingPerson" :securityPersonnel="securityPersonnel" :alternatePersonnel="alternatePersonnel" :rowLoopText="rowLoopText" :rowAddressText="rowAddressText" :relationList="relationAlarmInfoList" @refreshList="refreshAlarmList" @handleMain="handleMain" @tableActionPlay="handleActionPlay" @tableActionPosition="handleActionPosition" @handleClose="handleClose" @rowDetail="getRowInfo"></alarm-details>
      <!-- 消防设备图标 -->
      <img ref="cameraImg" class="alarm-img" draggable style="visibility: hidden; display: contents" src="../../../../public/images/theme/newDark/map/cameraCanvas.png" width="20" height="20" alt="" />
      <img ref="dqhzImg" class="alarm-img" draggable style="visibility: hidden; display: contents" src="../../../../src/common/assets/images/map/resource/dqhz.png" width="20" height="20" alt="" />
      <img ref="imgRed" class="alarm-img" draggable style="visibility: hidden; display: contents" src="../../../../public/images/theme/newDark/map/alarm_state/1_1.png" width="20" height="20" alt="" />
      <img ref="imgRed2" class="alarm-img" draggable style="visibility: hidden; display: contents" src="../../../../public/images/theme/newDark/map/alarm_state/2_1.png" width="20" height="20" alt="" />
      <img ref="imgRed3" class="alarm-img" draggable style="visibility: hidden; display: contents" src="../../../../public/images/theme/newDark/map/alarm_state/3_1.png" width="20" height="20" alt="" />
      <img ref="imgRed4" class="alarm-img" draggable style="visibility: hidden; display: contents" src="../../../../public/images/theme/newDark/map/alarm_state/4_1.png" width="20" height="20" alt="" />
      <img ref="img" style="visibility: hidden; display: contents" src="../../../../public/images/theme/newDark/device.png" width="20" height="20" alt="" />
      <img ref="imgCheck" style="visibility: hidden; display: contents" src="../../../../public/images/theme/newDark/deviceCheck.png" width="20" height="20" alt="" />
      <el-dialog title="运行数据" :visible.sync="linkDialog" width="1020px" v-dialogDrag>
        <ioc-table ref="crud" style="height: 500px" :data="workingData" :option="workingOptions" :page="workingPage" @size-change="personChangeSize" @search-reset="handleSearchReset" @search-change="handleSearchChange" @current-change="currentChange">
        </ioc-table>
      </el-dialog>
      <el-dialog title="告警信息" :visible.sync="alarmDialog" width="1020px" v-dialogDrag>
        <!-- <el-scrollbar class="flex-auto"
                      style="height:480px "> -->
        <ioc-table ref="crud" :data="alarmlistData" :option="alarmlistOptions" :page="workingPage" @size-change="personChangeSize" @current-change="currentChange">
        </ioc-table>
        <!-- </el-scrollbar> -->
      </el-dialog>
    </div>
    <info-edit ref="infoEditDialog" @refreshPop="getFireAlarmList(page, queryParams)"></info-edit>
    <alarmControl @alarmControl="alarmControl" ref="alarmContol"></alarmControl>
    <fireImg class="fireImg" ref="fireImg" style="visibility: hidden" />
    <!-- websocket推两点报警弹框 -->
    <two-point-dialog ref="multiAlarmDialog"></two-point-dialog>

    <el-dialog :visible.sync="fireMdialog" width="80%" v-dialogDrag :close-on-click-modal="false" :destroy-on-close="true">
      <fireMange></fireMange>
    </el-dialog>
    <!-- 图纸上面点位气泡 -->
    <deviceCanvasTip v-if="showDeviceTip" :data="currentPop" :showGY="showGY" :controlPageType="false" pageType="alarm" @equipmentOperation="equipmentOperation" @showOperationData="showOperationData" @alarmInfoList="alarmInfoList" @handAlarmControl="handalarmControl" @handleUpdateDevice="handleUpdateDevice" @tipClose="showDeviceTip = false" class="canvasTip" :style="{
        left: tipStyle.left + 'px',
        top: tipStyle.top + 'px',
      }" />
    <el-dialog title="一键误报处理" :visible.sync="dealVisible" append-to-body :close-on-click-modal="modalClose" width="50%" style="margin-top: 10px;">
      <div>
        <el-form ref="dealForm" :model="dealForm" inline label-width="90px">
          <el-form-item label="时间范围" prop="alarmTime">
            <el-date-picker v-model="dealForm.alarmTime" type="datetimerange" clearable value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="告警类型" prop="alarmType">
            <el-select v-model="dealForm.alarmType" clearable>
              <el-option v-for="item in alarmTypeArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="告警等级" prop="alarmLevel">
            <el-select v-model="dealForm.alarmLevel" placeholder="请选择">
              <el-option v-for="item in alarmLevelArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="detailQuery">查询</el-button>
            <el-button size="small" @click="detailReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="max-height: 480px; overflow-y: auto;">
        <el-table :data="dealAlarmData" @selection-change="handleSelectionChange" style="width: 100%">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="序号" type="index" width="70"></el-table-column>
          <el-table-column label="告警名称" prop="alarmName" show-overflow-tooltip></el-table-column>
          <el-table-column label="告警等级" prop="alarmLevel" :formatter="alarmLevelRender" show-overflow-tooltip></el-table-column>
          <el-table-column label="告警时间" prop="alarmTime" :formatter="alarmTimeRender" show-overflow-tooltip></el-table-column>
          <el-table-column label="告警类型" prop="alarmTypeLabel" show-overflow-tooltip></el-table-column>
          <el-table-column label="来源子系统" prop="subSystemLabel" show-overflow-tooltip></el-table-column>
          <el-table-column label="告警状态" prop="alarmState" :formatter="alarmStateRender" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dealConfirm">误报处理</el-button>
        <el-button @click="dealCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import deviceCanvasTip from "../components/deviceCanvasTip";
import { api } from "../api";
import { mapState } from "vuex";
import { Dic } from "$utils";
import utils from "@src/common/utils";
import alarmList from "../components/alarmList";
import FireAlarmList from "../components/FireAlarmList";
import alarmControl from "../../realTimeAlarm/components/alarmControl";
import alarmDetails from "../components/alarmDetails";
import twoPointDialog from "../components/twoPointDialog";
import infoEdit from "../components/infoEdit";
import { workingOptions } from "../config/operation";
import { tableOption } from "../config/alarmDetail";
import deviceMap from "../../cameraList/components/deviceMap";
import fireImg from "@src/modules/cameraList/components/fireImg";
import fireMange from "../../realTimeAlarm/view/FireManage";
import { mapMutations } from "vuex";

let dayjs = require("dayjs");
export default {
  components: {
    // alarmList,
    alarmControl,
    alarmDetails,
    fireImg,
    twoPointDialog,
    fireMange,
    infoEdit,
    FireAlarmList,
    deviceCanvasTip,
  },
  data() {
    return {
      tipStyle: { left: 0, top: 0 },
      workerOrderList: [],
      useNew: true,
      isMerge: false,
      groupCode: "", //查询安全组
      canvasLoading: false,
      fireMdialog: false,
      alarmDialog: false,
      showGY: false,
      showAlarm: true,
      cacheAlarmList: [],
      chiocedPersonArr: [], //执行组
      listType: _.map(Dic.find("SENU097003004")),
      page: {
        pageSize: 30,
        currentPage: 1,
        total: 0,
      },
      workingPage: {
        pageNum: 1,
        total: 10,
        alarmType: [],
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      // 消防告警列表查询参数
      queryParams: {
        alarmLevel: "", //级别
        alarmTypeList: [], //子系统类型
        subSystemList: [4, 13], //子系统类型
        deviceName: "",
        alarmMergeCodeList: [],
        alarmStartTime: "",
        alarmEndTime: "",
      },
      showType: 1, // 1 表示原始列表显示 2, 查询条件显示列表
      detailVisible: false,
      alarmId: "",
      drawingSrc: "",
      alarmDetail: {},
      // 详情页下两点报警table表格row点击获得的详情
      rowClickInfo: {},
      // a)	点击运行数据弹窗，显示部件运行的数据列表
      linkDialog: false,
      workingOptions: workingOptions(),
      alarmlistOptions: tableOption(),
      workingData: [],
      cW: 0,
      cH: 0,
      canvasList: [], //动态canvas
      canvasChangList: [], //静态态canvas
      hasDrawing: false,
      showDeviceTip: false,
      rowLoopText: "",
      rowAddressText: "",
      relationAlarmInfoList: [],
      // 点击单个告警时获取当前楼层的所有设备并去重告警设备的数组
      excludeAlarmDeviceArr: [],
      clickItem: {},
      deviceNameId: "",
      dialogType: "",
      currentPop: {},
      alarmLevelPng: "",
      tipAlarmInfo: {}, //气泡的告警详情
      buildingPerson: "", //详情页的楼栋管理员
      securityPersonnel: "", //详情页的楼栋安全员
      alternatePersonnel: "", //详情页的楼栋备用安全员
      deviceId: "",
      isGetResult: false,
      restLoading: false,
      alarmImgR: 60, //告警图片r
      devicdeR: 25, //设备图片R
      alarmlistData: [],
      editDesc: "",
      clickId: "",
      modalClose: false,
      dealVisible: false,
      dealForm: {
        alarmType: "",
        alarmLevel: "",
        alarmTime: [],
      },
      alarmTypeArr: [
        { label: "火警", value: 4001 },
        { label: "故障", value: 4002 },
        { label: "反馈", value: 4005 },
        { label: "其他信息", value: 40099 },
      ],
      alarmLevelArr: Dic.find("SENU017"),
      selectedItems: [],
      dealAlarmData: [],
    };
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
    ...mapState({
      fireAlarmNewList: (state) => state.ioc.fireAlarmNewList,
    }),
  },
  mixins: [deviceMap],
  watch: {
    getMarinLeft() {
      this.matchTip();
    },
    getMarginTop() {
      this.matchTip();
    },
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
    "$route.query.alarmId"() {
      this.alarmItemClick(this.$route.query);
    },
    // 监听告警弹窗 如果发现插入列表,2021/11 需求 上报告警直接刷新
    fireAlarmNewList(newVal) {
      if (newVal) {
        // 主机复位和部件正常运行需要重新请求\
        // if (newVal.alarmType == "40114" || newVal.alarmType == "40115") {
        // 如果是火警 则重置查询条件
        if (newVal.commonAlarmType == "4001") {
          this.queryParams.commonAlarmType = "";
          this.queryParams.alarmTypeList = [];
          this.queryParams.thirdAlarmDevId = "";
          this.queryParams.alarmTypeList = [];
          this.queryParams.alarmStartTime = "";
          this.queryParams.alarmEndTime = "";
          this.queryParams.alarmName = "";
          this.$refs.alarmList.$refs.left.resetBtn();
          // this.handleRestBtn()
        } else {
          this.getFireAlarmList(this.page, this.queryParams, false);
        }
        return;
        // }
      }

      // TDOD 判断websocket推过来的告警是否是两点报警，弹出弹框
      if (newVal.multiAlarmType == 2) {
        this.$refs.multiAlarmDialog.showAlarmDialog(
          newVal.alarmId,
          newVal.alarmDevId,
          true
        );
      }
      // // 推送过来的告警直接刷新，不在插入数据
      // if (newVal) {
      //   return
      // }
      if (!newVal || this.showType == 2) return;
      newVal.isExpand = false;
      newVal.alarmMergeFlag = this.$refs.alarmList.alarmMergeFlag;
      if (
        _.findIndex(this.cacheAlarmList, { alarmId: newVal.alarmId }) === -1
      ) {
        // console.log('不存在----');
        if (
          this.$refs.alarmList.lefTdata.length > 0 &&
          this.$refs.alarmList.lefTdata[0].alarmMergeCode ==
            newVal.alarmMergeCode
        ) {
          this.$refs.alarmList.lefTdata.unshift(newVal);
          // console.log("合并状态下添加leftData单条")
          this.listType.forEach((el) => {
            if (el.value == newVal.commonAlarmType) {
              el.num ? (el.num += 1) : 1;
            }
          });
          return;
        } else {
          // console.log('88888888888');
          let ishaveData = this.cacheAlarmList.some((el) => {
            return el.alarmMergeCode == newVal.alarmMergeCode;
          });
          if (newVal.alarmMergeFlag == 1 && ishaveData) {
            // console.log("合并状态下不添加")
            return;
          }
        }
        // console.log("没合并状态下添加，合并状态下添加")
        this.cacheAlarmList.unshift(newVal);
        this.listType.forEach((el) => {
          if (el.value == newVal.commonAlarmType) {
            el.num ? (el.num += 1) : 1;
          }
        });
        this.cacheAlarmList = _.orderBy(
          this.cacheAlarmList,
          ["alarmTime"],
          ["desc"]
        );
        // console.log(this.listType)
      }
      // console.log('this.cacheAlarmList-----', this.cacheAlarmList);
    },
  },
  created() {
    // 定时器 每隔一段时间自动刷新
    this.setInterval = setInterval(() => {
      this.getFireAlarmList(this.page, this.queryParams);
    }, 3 * 60 * 1000);
  },
  mounted() {
    this.clickPoints();
    this.getFireAlarmList(this.page, this.queryParams);
    this.getCanvasWH();
    let _this = this;
    window.onresize = function () {
      _this.watchScreen();
    };
  },
  beforeDestroy() {
    this.$app.AppInstance.handleMiniPlay();
    window.onresize = null;
    clearInterval(this.setInterval);
  },
  methods: {
    ...mapMutations({
      addToAlarmList: "ADD_ALARM_TO_LIST",
      removeFromAlarmList: "REMOVE_ALARM_FROM_LIST",
    }),
    handleDealShow() {
      this.dealForm.alarmTime = [
        this.timeRender(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
        this.timeRender(new Date().getTime()),
      ];
      this.dealVisible = true;
      this.detailQuery();
    },
    detailQuery() {
      let alarmStartTime = null;
      let alarmEndTime = null;
      if (this.dealForm.alarmTime && this.dealForm.alarmTime.length > 0) {
        alarmStartTime = this.dealForm.alarmTime[0];
        alarmEndTime = this.dealForm.alarmTime[1];
      }
      let params = {
        alarmStartTime: alarmStartTime,
        alarmEndTime: alarmEndTime,
        alarmLevel: this.dealForm.alarmLevel,
        commonAlarmType: this.dealForm.alarmType,
        subSystemList: [4, 13],
        alarmState: 1,
        pageNum: 1,
        pageSize: 10000,
      };
      this.$fetch(
        "/bas/alarmSafeEvent/queryFirefightingAlarmResultsByPage.json",
        params
      ).then((response) => {
        if (response.success) {
          this.dealAlarmData = response.returnObj
            ? response.returnObj.alarmList.list
            : [];
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleSelectionChange(selectuion) {
      this.selectedItems = selectuion;
    },
    detailReset() {
      this.dealForm.alarmType = "";
      this.dealForm.alarmLevel = "";
      this.dealForm.alarmTime = [
        this.timeRender(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
        this.timeRender(new Date().getTime()),
      ];
      this.detailQuery();
    },
    dealCancel() {
      this.dealVisible = false;
    },
    dealConfirm() {
      const self = this;
      if (this.selectedItems.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择告警数据",
        });
        return;
      }
      let ids = this.selectedItems.map((item) => {
        return item.alarmId;
      });
      this.$confirm("您确定要将选中的数据进行误报处理吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch("/bas/alarmSafeEvent/missBatchReport.json", {
          alarmIds: ids,
          alarmState: 3,
          processDesc: "",
        }).then((response) => {
          if (!response.success) {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "success",
              duration: 2000,
            });
            this.dealVisible = false;
            this.getFireAlarmList(this.page, this.queryParams);
            this.removeFromAlarmList();
          }
        });
      });
    },
    timeRender(data) {
      const nowTime = new Date(data);
      const y = nowTime.getFullYear();
      let M = nowTime.getMonth() + 1;
      M = M < 10 ? "0" + M : M;
      let d = nowTime.getDate();
      d = d < 10 ? "0" + d : d;
      let h = nowTime.getHours();
      h = h < 10 ? "0" + h : h;
      let m = nowTime.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = nowTime.getSeconds();
      s = s < 10 ? "0" + s : s;
      const currentDate = y + "-" + M + "-" + d;
      const currentTime = h + ":" + m + ":" + s;
      return currentDate + " " + currentTime;
    },
    alarmLevelRender(data) {
      const value = data.alarmLevel;
      for (let i = 0; i < this.alarmLevelArr.length; i++) {
        if (this.alarmLevelArr[i].value == value) {
          return this.alarmLevelArr[i].label;
        }
      }
    },
    alarmStateRender(data) {
      const value = data.alarmState;
      if (value == 1) {
        return "待处理";
      } else if (value == 4) {
        return "已下发任务(处理中)";
      } else if (value == 10) {
        return "已下发任务(已完成)";
      }
    },
    alarmTimeRender(data) {
      const nowTime = new Date(data.alarmTime);
      const y = nowTime.getFullYear();
      let M = nowTime.getMonth() + 1;
      M = M < 10 ? "0" + M : M;
      let d = nowTime.getDate();
      d = d < 10 ? "0" + d : d;
      let h = nowTime.getHours();
      h = h < 10 ? "0" + h : h;
      let m = nowTime.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = nowTime.getSeconds();
      s = s < 10 ? "0" + s : s;
      const currentDate = y + "-" + M + "-" + d;
      const currentTime = h + ":" + m + ":" + s;
      return currentDate + " " + currentTime;
    },
    handleActionPlay(item) {
      this.playVideo("live", item);
    },
    // 定位居中
    handleActionPosition(item) {
      // console.log(item);
      // console.log(this.alarmDetail);
      this.clickItem = item;
      this.getDeviceDetails(item.deviceId);
      this.showGY =
        this.clickItem.deviceId == this.alarmDetail.alarmDevId ? true : false;
      let wb = this.cW / item.width;
      let hb = this.cH / item.height;
      this.vW = 100;
      this.vH = 100;
      // 使点位的位置居页面中心
      this.marginLeft = (this.cW - 380) / 2 - wb * item.abscissa;
      this.marginTop = this.cH / 2 - hb * item.ordinate;
      // this.$nextTick(() => {
      // this.clearCanvas("mycanvas2");
      // this.getCanvasWH();
      // let ctx = this.initCanvas("mycanvas2");
      // let img = this.$refs.imgCheck;
      // ctx.drawImage(img, item.abscissa * wb - 12.5, item.ordinate * hb - 12.5, 25, 25);
      // ctx.font = "12pt Arial";
      // ctx.fillStyle = "#ff0000";
      // ctx.fillText(
      //   "【类型：" + Dic.findByValue("SENU087", item.deviceMark) + "】",
      //   Math.round(wb * item.abscissa) - 20,
      //   Math.round(hb * item.ordinate)
      // );
      // ctx.fillText(
      //   "【名称：" + item.deviceName + "】",
      //   Math.round(wb * item.abscissa) - 20,
      //   Math.round(hb * item.ordinate - 20)
      // );
      // });
    },
    playVideo(type = "live", item = {}) {
      // item是周边设备资源播放的
      this.$app.AppInstance.handleMiniPlay({
        playType: "live", // 'live',
        playTitle:
          item.deviceName ||
          this.currentPop.deviceName ||
          this.currentPop.cameraName, //摄像机名称
        playId:
          item.thirdDeviceId ||
          this.currentPop.thirdDeviceId ||
          this.currentPop.thirdCameraId, //摄像机id
      });
    },
    alarmInfoList() {
      this.workingPage.pageNum = 1;
      this.workingPage.pageSize = 10;
      this.workingPage.total = 0;
      this.getalarmData();
      this.alarmDialog = true;
    },
    getalarmData() {
      let params = {
        // thirdDeviceId: this.alarmDetail.thirdAlarmDevId,
        thirdDeviceId: this.clickItem.thirdDeviceId,
        pageNum: this.workingPage.pageNum,
        pageSize: this.workingPage.pageSize,
      };
      this.$fetch(api.alarm.getalarmList, params).then((response) => {
        if (response.success) {
          this.alarmlistData = response.returnObj.list;
          this.workingPage.total = response.returnObj
            ? response.returnObj.total
            : 0;
        } else {
          this.$message.error(response.msgContent || "获取告警信息失败");
        }
      });
    },
    handleSearchReset() {
      this.workingPage.alarmType = [];
      // this.workingPage.pageNum = 1
      // this.workingPage.pageSize = 10
      this.getWorkingData();
    },
    handleSearchChange(param) {
      this.workingPage.alarmType = [];
      param.statusDesc &&
        this.workingPage.alarmType.push(param.statusDesc.toString());
      this.getWorkingData();
    },
    // 告警详情--操作消防主机回调
    handleMain() {
      let newMsg = window.location.href.split("#")[0];
      let id = "";
      if (this.alarmDetail.ctrlDeviceId) {
        id = this.alarmDetail.ctrlDeviceId;
      } else {
        id = this.alarmDetail.alarmDevId || this.alarmDetail.parentDeviceId;
      }
      window.open(
        newMsg +
          "#/fireManage?id=" +
          id +
          "&alarmType=" +
          this.alarmDetail.alarmType +
          "&alarmFire=" +
          (this.alarmDetail.alarmId + "-" + this.alarmDetail.alarmState)
      );

      // this.$router.push({
      //   path: "/fireManage",
      //   name: "fireManage",
      //   query: {
      //     id: this.alarmDetail.alarmDevId || this.alarmDetail.parentDeviceId,
      //     alarmType: this.alarmDetail.alarmType,
      //     alarmFire:
      //       this.alarmDetail.alarmId + "-" + this.alarmDetail.alarmState,
      //   },
      // });
    },
    addCamera() {
      this.$refs.multiAlarmDialog.showAlarmDialog(
        20210416000081,
        "20210331016772",
        true
      );
    },
    alarmControl(val, data) {
      let params = {
        subSystem: data.subSystem,
        alarmType: data.alarmType,
        alarmDevId: data.alarmDevId,
        deviceName: data.deviceName,
        alarmInterval: val.num,
        beginTime: val.ignoreTime ? val.ignoreTime[0] : "",
        endTime: val.ignoreTime ? val.ignoreTime[1] : "",
      };
      this.$fetch(api.cms.addAlarmIgnoreConfig, params).then((res) => {
        if (res.success) {
          this.$message.success("告警抑制配置成功");
          this.$refs.alarmContol.closeDialog();
        } else {
          this.$refs.alarmContol.sbmitLoading = false;
          this.$message.error(res.msgContent);
        }
      });
    },
    // 告警抑制
    handalarmControl(val) {
      let params = {
        subSystem: val.subSystem,
        alarmType: val.alarmType,
        alarmDevId: val.alarmDevId || val.parentDeviceId,
      };
      this.$fetch(api.cms.queryAlarmIgnoreConfigInfo, params).then((res) => {
        if (res.success) {
          let data = res.returnObj;
          this.$refs.alarmContol.formDialog = {
            ignoreTime:
              data && data.beginTime ? [data.beginTime, data.endTime] : [],
            num: data ? data.alarmInterval : null,
          };
          this.$refs.alarmContol.alarmData = val;
          this.$refs.alarmContol.controlDialog = true;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //误报处理
    resetError(val) {
      this.$refs.details.ignoreAlarmAll(val);
    },
    // 数量点击事件
    handTypeChange(val) {
      this.page.currentPage = 1;
      // this.queryParams.alarmTypeList = [val];
      this.queryParams.commonAlarmType = val;
      this.getFireAlarmList(this.page, this.queryParams);
    },
    // 告警列表 右击事件
    handRightClick(val) {
      this.page.currentPage = 1;
      this.cacheAlarmList = [];
      this.getFireAlarmList(this.page, this.queryParams);
    },
    refreshAlarmList() {
      this.getFireAlarmList(this.page, this.queryParams);
    },
    // 两点报警中table中row点击获取告警详情
    getRowInfo(id) {
      this.buildingPerson = "";
      this.securityPersonnel = "";
      this.alternatePersonnel = "";
      let params = {
        alarmId: id,
      };
      this.$fetch(api.alarm.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.rowClickInfo = response.returnObj;
          // if (this.rowClickInfo.thirdAlarmDevId && this.rowClickInfo.subDeviceMark) {
          //   let arr = this.rowClickInfo.thirdAlarmDevId.split("-")
          //   if (arr.length === 3) {
          //     this.rowLoopText = arr[1]
          //     this.rowAddressText = arr[2]
          //   } else {
          //     this.rowLoopText = arr[2]
          //     this.rowAddressText = arr[3]
          //   }
          // }

          if (
            this.rowClickInfo.buildingPersonnel &&
            this.rowClickInfo.buildingPersonnel.personnelName
          ) {
            this.buildingPerson =
              this.rowClickInfo.buildingPersonnel.personnelName +
              "(" +
              this.rowClickInfo.buildingPersonnel.personnelPhone +
              ")";
          }
          if (
            this.rowClickInfo.securityPersonnelList &&
            this.rowClickInfo.securityPersonnelList.length
          ) {
            this.rowClickInfo.securityPersonnelList.forEach((item, index) => {
              this.securityPersonnel +=
                item.personnelName + "(" + item.personnelPhone + ")、";
            });
            this.securityPersonnel = this.securityPersonnel.substring(
              0,
              this.securityPersonnel.lastIndexOf("、")
            );
          }

          if (
            this.rowClickInfo.alternatePersonnelList &&
            this.rowClickInfo.alternatePersonnelList.length
          ) {
            this.rowClickInfo.alternatePersonnelList.forEach((item, index) => {
              this.alternatePersonnel +=
                item.personnelName + "(" + item.personnelPhone + ")、";
            });
            this.alternatePersonnel = this.alternatePersonnel.substring(
              0,
              this.alternatePersonnel.lastIndexOf("、")
            );
          }
        } else {
          this.$message.error(response.msgContent || "获取消防告警详情失败");
        }
      });
    },
    // 获取消防告警列表
    getFireAlarmList(page, params, isRefresh = true) {
      const _this = this;
      this.$refs.alarmList.dataLoading = true;
      // 筛选条件存储在弹窗告警时使用
      let obj = {};
      params.commonAlarmType
        ? (obj.commonAlarmType = params.commonAlarmType)
        : "";
      params.thirdAlarmDevId
        ? (obj.thirdAlarmDevId = params.thirdAlarmDevId)
        : "";
      // params.alarmName = params.deviceName
      this.$fetch(
        api.alarm.getAlarmPageList,
        Object.assign(
          {
            pageNum: page.currentPage,
            pageSize: page.pageSize,
          },
          params
        )
      ).then((response) => {
        setTimeout(() => {
          this.$refs.alarmList.dataLoading = false;
        }, 200);
        if (response && response.success) {
          this.$refs.alarmList.alarmMergeFlag =
            response.returnObj.alarmMergeFlag;
          // 列表
          response.returnObj.alarmList.list.forEach((el) => {
            el.isExpand = false;
          });
          // 类型
          let TypeObj = response.returnObj.commonAlarmTypeCount; //mapCount
          if (!this.listType.length) {
            this.timer = setTimeout(() => {
              this.listType = _.map(Dic.find("SENU097003004"));
              if (this.listType.length) {
                this.listType.forEach((el) => {
                  el.num = TypeObj[el.value];
                });
                clearTimeout(this.timer);
              }
            }, 100);
          } else {
            clearTimeout(this.timer);
            this.listType.forEach((el) => {
              el.num = TypeObj[el.value];
            });
          }
          // console.log(this.listType)
          if (page.currentPage === 1) {
            _this.cacheAlarmList = [];
          }
          _this.alarmList = response.returnObj
            ? response.returnObj.alarmList.list
            : [];
          if (this.cacheAlarmList.length === 1000) {
            this.cacheAlarmList.splice(0, this.page.pageSize);
          }
          // this.alarmList = [...this.alarmList, ...this.alarmList, ...this.alarmList, ...this.alarmList, ...this.alarmList, ...this.alarmList, ...this.alarmList, ...this.alarmList]
          // this.alarmList = []
          _this.cacheAlarmList = this.cacheAlarmList.concat(_this.alarmList);
          _this.cacheAlarmList = _.orderBy(
            _this.cacheAlarmList,
            ["alarmTime"],
            ["desc"]
          );
          _this.page.total = response.returnObj
            ? response.returnObj.alarmList.total
            : 0;
          if (_this.cacheAlarmList.length == 0) {
            this.noData = true;
          }
          // 获取查询到的告警点位
          // this.canvasList = [];
          // _this.cacheAlarmList.forEach(item => {
          //   this.clearCanvas()
          //   let wb = this.cW / item.width;
          //   let hb = this.cH / item.height;
          //   this.canvasList.push({
          //     width: item.width,//原始大小
          //     height: item.height,//原始大小
          //     x: item.abscissa,
          //     y: item.ordinate,
          //     ...item
          //   });
          //   let ctx = this.initCanvas();
          //   let img = this.$refs.imgRed;
          //   ctx.drawImage(img, item.abscissa * wb - 20, item.ordinate * hb - 20, 40, 40);
          // })
          // console.log('-this.canvasList---', this.canvasList);
          if (isRefresh) {
            _this.cacheAlarmList.length &&
              this.getAlarmDetails(_this.cacheAlarmList[0].alarmId);
            this.$refs.details.activeName = 0;
            this.$refs.alarmList.clickId = _this.cacheAlarmList[0].alarmId;
          }
        }
      });
    },
    // 根据级联下拉框查询告警列表
    handleSearchTypeLever(val, type) {
      // 1子系统类型  2级别 3 子系统
      this.page.currentPage = 1;
      this.showType = 2;
      // 子系统、
      this.queryParams.subSystemList[0] = val;
      this.queryParams.alarmTypeList = [type];
      this.getFireAlarmList(this.page, this.queryParams);
    },
    // 根据设备名称及告警时间面板中的查询按钮查询告警列表
    handleSearchBtn(item) {
      this.page.currentPage = 1;
      this.queryParams.thirdAlarmDevId = item.thirdAlarmDevId;
      this.queryParams.commonAlarmType = "";
      // item.deviceName ? item.deviceName != '全部' ? this.queryParams.deviceName = item.deviceName : this.queryParams.deviceName = '' : ''
      item.deviceName
        ? item.deviceName != "全部"
          ? (this.queryParams.thirdAlarmDevId = item.id)
          : (this.queryParams.thirdAlarmDevId = "")
        : "";
      this.getFireAlarmList(this.page, this.queryParams);
      this.deviceId = item.deviceId;
    },
    // 根据设备名称查告警列表
    handleSearchDeviceName(val) {
      this.queryParams.alarmName = val;
      this.page.currentPage = 1;
      this.showType = 2;
    },
    // 根据告警时间查告警列表
    handleSearchAlarmTime(val) {
      this.queryParams.alarmStartTime = val[0];
      this.queryParams.alarmEndTime = val[1];
      this.page.currentPage = 1;
      this.showType = 2;
    },
    // 重置查询条件
    handleRestBtn() {
      this.queryParams.alarmLevel = "";
      this.queryParams.alarmTypeList = [];
      this.queryParams.alarmStartTime = "";
      this.queryParams.alarmEndTime = "";
      this.queryParams.thirdAlarmDevId = "";
      this.queryParams.alarmName = "";
      // alarmLevel: "",
      // alarmTypeList: [],
      // subSystemList: this.queryParams.subSystemList,
      // // deviceName: "",
      // alarmStartTime: "",
      // alarmEndTime: "",
      this.getFireAlarmList(this.page, this.queryParams);
    },
    // 滚动加载告警列表数据
    loadMoreAlarm() {
      this.page.currentPage = this.page.currentPage + 1;
      this.getFireAlarmList(this.page, this.queryParams);
    },
    handleActiveChange(val) {
      clearInterval(this.setInterval);
      this.$refs.details.taskPanelVisible = false;
      this.$refs.details.activeName = 0;
      this.$refs.details.dialogVisible = false;
      this.clearCanvas();
      this.clearCanvas("mycanvas2");
      this.showDeviceTip = false;
      this.alarmDetail = {};
      this.hasDrawing = false;
      if (val === 0) {
        this.getFireAlarmList(this.page, this.queryParams);
        this.setInterval = setInterval(() => {
          this.getFireAlarmList(this.page, this.queryParams);
        }, 3 * 60 * 1000);
      }
    },
    handleNodeClick(data) {
      // this.clearCanvas();
      this.clearCanvas("mycanvas2");
      this.showDeviceTip = false;
      this.drawingSrc = data.fileCode;
      this.hasDrawing = true;
      this.canvasList = [];
      // 判断告警详情接口响应消息buildingCode字段是否为空，如果不为空，则调用根据楼栋/楼层查询设备列表接口 将该楼层下的所有设备打点
      if (data.buildingCode) {
        let params = {
          buildingCode: data.buildingCode,
        };
        this.$fetch(api.device.queryDeviceListByBuilding, params).then(
          (response) => {
            if (response.success) {
              setTimeout(() => {
                this.canvasLoading = false;
              }, 200);
              this.canvasChangList = [];
              response.returnObj.forEach((item, index) => {
                // if (item.alarmId) {
                // this.canvasList.push({
                //   width: item.width, //原始大小
                //   height: item.height, //原始大小
                //   alarmLevel: item.alarmLevel, //item.alarmId.split("|")[1]  1,//根据不同级别展示不同颜色
                //   x: item.abscissa,
                //   y: item.ordinate,
                //   ...item,
                // });
                // console.log(this.canvasList)
                // let ctx = this.initCanvas();
                // let img = this.$refs.imgRed;
                // ctx.drawImage(img, item.abscissa * wb - 20, item.ordinate * hb - 20, 40, 40);
                // } else {
                let img2 = this.$refs.img;
                // 此处需要判断改点位是否是部件无点位是的主机点位
                if (this.alarmDetail.hostPositionFlag == 1) {
                  // 需要过滤掉主机点位
                  if (
                    this.alarmDetail.ordinate == item.ordinate &&
                    this.alarmDetail.abscissa == item.abscissa &&
                    this.alarmDetail.width == item.width &&
                    this.alarmDetail.height == item.height
                  ) {
                    return false;
                  }
                }
                // 设备打点--静态图层
                if (item.deviceMark == 32) {
                  // 电器火灾
                  img2 = this.$refs.dqhzImg;
                }
                if (item.deviceMark == 18) {
                  //摄像机
                  img2 = this.$refs.cameraImg;
                }
                let wb = this.cW / item.width;
                let hb = this.cH / item.height;
                // let img = this.$refs.img
                this.canvasChangList.push({
                  width: item.width, //原始大小
                  height: item.height, //原始大小
                  x: item.abscissa,
                  y: item.ordinate,
                  ...item,
                });
                let ctx2 = this.initCanvas("mycanvas2");
                // console.log(this.canvasChangList)
                ctx2.drawImage(
                  img2,
                  item.abscissa * wb - 12.5,
                  item.ordinate * hb - 12.5,
                  25,
                  25
                );
                // }
              });
            } else {
              this.canvasLoading = false;
              this.$message.error(
                response.msgContent || "获取楼层下设备数据失败"
              );
            }
          }
        );
      } else {
        this.canvasLoading = false;
      }
    },
    // 单个告警查看详情
    alarmItemClick(item) {
      item.alarmMergeFlag == "1"
        ? (this.isMerge = true)
        : (this.isMerge = false);
      this.resetErrorType = item.alarmMergeCode;
      this.groupCode = item.groupCode;

      this.vW = 100;
      this.vH = 100;
      this.marginLeft = 0;
      this.moveXDistance = 0;
      this.marginTop = 0;
      this.moveYDistance = 0;
      this.canvasLoading = true;
      this.clearCanvas();
      this.clearCanvas("mycanvas2");
      this.rowClickInfo = {};
      this.showDeviceTip = false;
      this.$refs.details.handleClose();
      this.alarmId = item.alarmId;
      this.getAlarmDetails(this.alarmId, "click");
      this.$nextTick(() => {
        this.$refs.details.showDetailDialog(item);
        this.$refs.details.activeName = 0;
      });
    },
    // 获取工单
    getWorkerOrder(taskCode) {
      this.$fetch(api.alarm.queryTaskInfo, { taskCode: taskCode }).then(
        (res) => {
          if (res.success) {
            this.workerOrderList = Object.freeze(
              res.returnObj.taskExecutionLogList
            );
          } else {
            this.$message({
              message: res.msgContent,
              type: "error",
            });
          }
        }
      );
    },
    // 获取告警详情
    getAlarmDetails(id, type) {
      this.buildingPerson = "";
      this.securityPersonnel = "";
      this.alternatePersonnel = "";
      let params = {
        alarmId: id,
      };
      this.clearCanvas("mycanvas2");
      this.$fetch(api.alarm.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.canvasChangList = [];
          this.alarmDetail = response.returnObj;
          this.$refs.details.getData(this.alarmDetail);
          this.relationAlarmInfoList = response.returnObj.relationAlarmInfoList;
          // 获取处置工单
          if (
            this.alarmDetail.alarmState == 4 ||
            this.alarmDetail.alarmState == 10
          ) {
            this.getWorkerOrder(this.alarmDetail.taskCode);
          }
          // thirdAlarmDevId主机编号-分机编号-回路-部件编号（部件地址）
          if (type == "click") {
            if (
              this.alarmDetail.buildingPersonnel &&
              this.alarmDetail.buildingPersonnel.personnelName
            ) {
              this.buildingPerson =
                this.alarmDetail.buildingPersonnel.personnelName +
                "(" +
                this.alarmDetail.buildingPersonnel.personnelPhone +
                ")";
            }
            if (
              this.alarmDetail.securityPersonnelList &&
              this.alarmDetail.securityPersonnelList.length
            ) {
              this.alarmDetail.securityPersonnelList.forEach((item, index) => {
                this.securityPersonnel +=
                  item.personnelName + "(" + item.personnelPhone + ")、";
              });
              this.securityPersonnel = this.securityPersonnel.substring(
                0,
                this.securityPersonnel.lastIndexOf("、")
              );
            }

            if (
              this.alarmDetail.alternatePersonnelList &&
              this.alarmDetail.alternatePersonnelList.length
            ) {
              this.alarmDetail.alternatePersonnelList.forEach((item, index) => {
                this.alternatePersonnel +=
                  item.personnelName + "(" + item.personnelPhone + ")、";
              });
              this.alternatePersonnel = this.alternatePersonnel.substring(
                0,
                this.alternatePersonnel.lastIndexOf("、")
              );
            }
          }
          // 支持消防告警描述可修改
          if (this.alarmDetail.subSystem == "4") {
            if (this.alarmDetail.desc) {
              this.editDesc = this.alarmDetail.desc;
            } else {
              if (this.alarmDetail.buildingName) {
                this.editDesc = `在${
                  this.alarmDetail.buildingName
                }位置,${Dic.findByValue(
                  "SENU094",
                  Number(this.alarmDetail.subDeviceMark)
                )}上报${this.alarmDetail.commonAlarmTypeLabel}`;
              } else {
                this.editDesc = `${Dic.findByValue(
                  "SENU094",
                  Number(this.alarmDetail.subDeviceMark)
                )}上报${this.alarmDetail.commonAlarmTypeLabel}`;
              }
            }
            this.$refs.details.setDescInfo(this.editDesc);
          }

          this.drawingSrc = this.alarmDetail.buildingFileCode;
          this.hasDrawing = true;
          let fireTreeData = [];
          this.canvasList = [];
          fireTreeData.push(this.alarmDetail);
          fireTreeData.forEach((item) => {
            // this.alarmLevelPng = `images/theme/light/map/alarm_state/${item.alarmLevel}_1.png`
            this.clearCanvas();
            let wb = this.cW / item.width;
            let hb = this.cH / item.height;
            this.canvasList.push({
              width: item.width, //原始大小
              height: item.height, //原始大小
              alarmLevel: item.alarmLevel || 1,
              x: item.abscissa,
              y: item.ordinate,
              ...item,
            });
            let ctx = this.initCanvas();
            let name =
              item.alarmLevel == 1 ? "imgRed" : "imgRed" + item.alarmLevel;
            let img = this.$refs[name];
            // 点击列表闪烁选中数据
            ctx.drawImage(
              img,
              item.abscissa * wb - 30,
              item.ordinate * hb - 30,
              60,
              60
            );
          });
          // 判断告警详情接口响应消息buildingCode字段是否为空，如果不为空，则调用根据楼栋/楼层查询设备列表接口 将该楼层下的所有设备打点
          if (this.alarmDetail.floorCode) {
            this.getFireDeviceByFloor(this.alarmDetail);
          } else {
            this.canvasLoading = false;
          }
        } else {
          this.canvasLoading = false;
          this.$message.error(response.msgContent || "获取消防告警详情失败");
        }
      });
    },
    handleConfirm() {},
    // 右侧详情关闭回调
    handleClose() {
      let ctx = this.initCanvas();
      // let img = this.$refs.imgRed;
      this.canvasList.forEach((item) => {
        let name = item.alarmLevel == 1 ? "imgRed" : "imgRed" + item.alarmLevel;
        let img = this.$refs[name];
        let wb = this.cW / item.width;
        let hb = this.cH / item.height;
        ctx.drawImage(
          img,
          item.abscissa * wb - 30,
          item.ordinate * hb - 30,
          60,
          60
        );
      });
    },
    getFireDeviceByFloor(floor) {
      let params = {
        buildingCode: floor.floorCode,
        alarmTime: dayjs(new Date(floor.alarmTime).getTime()).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
      this.$fetch(api.device.queryDeviceListByBuilding, params).then(
        (response) => {
          if (response.success) {
            setTimeout(() => {
              this.canvasLoading = false;
            }, 200);
            // if (this.alarmDetail.hostPositionFlag != 1) {
            //   this.canvasList = [];
            // }
            this.canvasChangList = [];
            response.returnObj.forEach((item, index) => {
              if (item.alarmId) {
                // 告警打点
                // this.clearCanvas()
                // let wb = this.cW / item.width;
                // let hb = this.cH / item.height;
                // this.canvasList.push({
                //   width: item.width, //原始大小
                //   height: item.height, //原始大小
                //   alarmLevel: item.alarmLevel, //item.alarmId.split("|")[1]  1,//根据不同级别展示不同颜色
                //   x: item.abscissa,
                //   y: item.ordinate,
                //   ...item,
                // });
                // let ctx = this.initCanvas();
                // let img = this.$refs.imgRed;
                // ctx.drawImage(img, item.abscissa * wb - 20, item.ordinate * hb - 20, 40, 40);
              } else {
                let img2 = this.$refs.img;
                // 此处需要判断改点位是否是部件无点位是的主机点位
                if (this.alarmDetail.hostPositionFlag == 1) {
                  // 需要过滤掉主机点位
                  if (
                    this.alarmDetail.ordinate == item.ordinate &&
                    this.alarmDetail.abscissa == item.abscissa &&
                    this.alarmDetail.width == item.width &&
                    this.alarmDetail.height == item.height
                  ) {
                    return false;
                  }
                }
                // 设备打点--静态图层
                if (item.deviceMark == 32) {
                  // 电器火灾
                  img2 = this.$refs.dqhzImg;
                }
                if (item.deviceMark == 18) {
                  //摄像机
                  img2 = this.$refs.cameraImg;
                }
                let wb = this.cW / item.width;
                let hb = this.cH / item.height;
                // let img = this.$refs.img
                this.canvasChangList.push({
                  width: item.width, //原始大小
                  height: item.height, //原始大小
                  x: item.abscissa,
                  y: item.ordinate,
                  ...item,
                });
                let ctx2 = this.initCanvas("mycanvas2");
                // console.log(this.canvasChangList)
                ctx2.drawImage(
                  img2,
                  item.abscissa * wb - 12.5,
                  item.ordinate * hb - 12.5,
                  25,
                  25
                );
              }
            });
            // console.log('response.returnObj', response.returnObj);
          } else {
            this.canvasLoading = false;
            this.$message.error(
              response.msgContent || "获取楼层下设备数据失败"
            );
          }
        }
      );
    },
    // 计算弹窗位置
    matchTip() {
      // console.log(this.clickItem);
      // console.log(this.currentPop);
      if (this.clickItem && this.showDeviceTip) {
        // this.clickItem.forEach((el) => {
        let el = this.clickItem;
        let wb = this.cW / el.width;
        let hb = this.cH / el.height;
        let checkId = this.clickItem.alarmDevId || this.clickItem.deviceId;
        // 显示该设备tip
        if (checkId == this.currentPop.deviceId) {
          this.tipStyle.left = Math.round(
            el.abscissa * wb + this.getMarinLeft + 192
          );
          this.tipStyle.top = Math.round(
            el.ordinate * hb + this.getMarginTop + 25
          );
        }
        // });
      }
    },
    //查询设备详情--弹窗详情使用（如果是告警 则调告警详情）
    getDeviceDetails(id) {
      this.tipAlarmInfo = {};
      let params = {
        deviceId: id,
      };
      // 设备详情
      this.$fetch(api.device.getDeviceDetails, params).then((response) => {
        if (response.success) {
          this.currentPop = response.returnObj.deviceInfo;
          this.showDeviceTip = true;
          this.matchTip();
        } else {
          this.$message.error(response.msgContent || "获取设备详情失败");
        }
      });
      // 告警详情
      if (this.clickItem.alarmId) {
        this.$fetch(api.alarm.queryAlarmDetail, {
          alarmId: this.clickItem.alarmId,
        }).then((response) => {
          if (response.success) {
            this.tipAlarmInfo = response.returnObj;
          }
        });
      }
    },
    showAlarmImg(item, wb, hb, isglint = false) {
      // if (isglint) {
      //   console.log(1)
      //   this.clearCanvas('mycanvas2')
      //   let ctx = this.initCanvas('mycanvas2');
      //   let img = this.$refs.img
      //   this.$nextTick(() => {
      //     ctx.drawImage(img, item.abscissa * wb - 20, item.ordinate * hb - 20, 20, 20);
      //   })
      //   return
      // }
      // console.log(item)
      this.clearCanvas();
      let ctx = this.initCanvas();
      // let img = this.$refs.imgRed
      let name = "";
      item.alarmLevel == 1
        ? (name = "imgRed")
        : (name = "imgRed" + item.alarmLevel || "");
      // let img = this.$refs.imgRed
      this.$nextTick(() => {
        ctx.drawImage(
          this.$refs[name],
          item.abscissa * wb - 30,
          item.ordinate * hb - 30,
          60,
          60
        );
      });
    },
    handleUpdateDevice() {
      console.log(12);
      this.$refs.infoEditDialog.open(this.currentPop, this.clickId);
    },
    equipmentOperation() {
      if (this.tipAlarmInfo.alarmId) {
        // 告警气泡
        let newMsg = window.location.href.split("#")[0];
        window.open(
          newMsg +
            "#/fireManage?id=" +
            (this.tipAlarmInfo.alarmDevId || this.tipAlarmInfo.parentDeviceId) +
            "&alarmType=" +
            this.tipAlarmInfo.alarmType +
            "&alarmFire=" +
            (this.tipAlarmInfo.alarmId + "-" + this.tipAlarmInfo.alarmState)
        );
      } else {
        // 设备气泡
        let newMsg = window.location.href.split("#")[0];
        window.open(newMsg + "#/fireManage?id=" + this.currentPop.deviceId);
      }
    },
    showOperationData2(id) {
      if (this.dialogType != 2) {
        this.workingPage.pageNum = 1;
        this.workingPage.pageSize = 10;
      }
      this.dialogType = 2;
      this.deviceNameId = id;
      this.linkDialog = true;
      this.getWorkingData();
    },
    restDevice() {
      this.restLoading = true;
      this.$fetch(api.controlRecord.updateAlarmHostReset, {
        thirdAlarmDevId: this.queryParams.thirdAlarmDevId,
      }).then((response) => {
        if (response.success) {
          this.sendControl();
          // this.$message.success(response.msgContent || "主机复位成功");
        } else {
          this.restLoading = false;
          this.$message.error(response.msgContent || "主机复位失败");
        }
      });
    },
    // 确定发送复位指令
    sendControl() {
      let params = {
        deviceId: this.deviceId,
        cmdKey: "86",
        operateType: 1, //1：单键操作，2：一键操作
        typeSign: 140,
        needUnLockFlag: 0,
      };
      (this.isGetResult = false),
        this.$fetch(api.controlRecord.controlFirefighting, params).then(
          (res) => {
            if (res && res.success) {
              this.getFireAlarmList(this.page, this.queryParams);
              // 开始查询控制回调
              this.getResult(res.returnObj);
              setTimeout(() => {
                if (!this.isGetResult) {
                  this.$message.success("复位成功");
                  this.isGetResult = true;
                  this.restLoading = false;
                }
              }, 5000);
            } else {
              this.restLoading = false;
              res.msgContent && this.$message.error(res.msgContent);
            }
          }
        );
    },
    // 获取指令处理结果
    getResult(val) {
      let params = {
        recordCode: val,
      };
      this.$fetch(api.controlRecord.queryFirefightingControlReply, params).then(
        (res) => {
          if (res && res.success) {
            if (res.returnObj == -1) {
              // 10s继续调用
              setTimeout(() => {
                !this.isGetResult ? this.getResult(val) : "";
              }, 2000);
            } else {
              this.restLoading = false;
              this.isGetResult = true;
              this.$message.success("复位操作成功");
            }
          } else {
            this.restLoading = false;
            res.msgContent && this.$message.error(res.msgContent);
          }
        }
      );
    },
    showOperationData() {
      if (this.alarmDetail.thirdAlarmDevId) {
        this.linkDialog = true;
        if (this.dialogType != 1) {
          this.workingPage.pageNum = 1;
          this.workingPage.pageSize = 10;
        }
        this.dialogType = 1;

        this.getWorkingData();
      } else {
        this.$message.warning("设备编号为空");
      }
    },
    // 获取运行数据列表
    getWorkingData() {
      // console.log(this.currentPop)
      // console.log(this.alarmDetail)
      let params = {
        // thirdDeviceId: this.alarmDetail.thirdAlarmDevId,
        // deviceId: this.dialogType == 2 ? this.deviceNameId : this.alarmDetail.alarmDevId,
        deviceId:
          this.dialogType == 2 ? this.deviceNameId : this.currentPop.deviceId,
        alarmTypeList: this.workingPage.alarmType,
        pageNum: this.workingPage.pageNum,
        pageSize: this.workingPage.pageSize,
      };
      this.$fetch(api.alarm.getWorkingList, params).then((response) => {
        if (response.success) {
          this.workingData = response.returnObj.list;
          this.workingPage.total = response.returnObj
            ? response.returnObj.total
            : 0;
        } else {
          this.$message.error(response.msgContent || "获取消防告警详情失败");
        }
      });
    },
    personChangeSize(val) {
      this.workingPage.pageNum = 1;
      this.workingPage.pageSize = val;
      if (this.alarmDialog) {
        this.getalarmData();
        return;
      }
      this.getWorkingData();
    },
    currentChange(val) {
      this.workingPage.pageNum = val;
      if (this.alarmDialog) {
        this.getalarmData();
        return;
      }
      this.getWorkingData();
    },
    // 窗口改变事件
    watchScreen() {
      this.getCanvasWH();
    },
    // 获取canvas father W H
    getCanvasWH() {
      // this.showDeviceTip = false;
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.redrawImg(10);
      this.matchTip();
    },
    // 画布点击 && 回调
    clickPoints() {
      let that = this;
      var canvas = document.getElementById("mycanvas2");
      var ctx = canvas.getContext("2d");
      canvas.addEventListener("click", function (e) {
        that.showPopover(e);
      });
    },
    showPopover(e) {
      // console.log(this.canvasList);
      // console.log(this.canvasChangList);
      // console.log(this.alarmDetail);
      // 点击相对坐标
      let x = e.offsetX;
      let y = e.offsetY;
      //动态点击选中数据
      let clickData = this.canvasList.filter((el, index) => {
        let wb = this.cW / el.width;
        let hb = this.cH / el.height;
        return (
          Math.pow(x - el.x * wb, 2) + Math.pow(y - el.y * hb, 2) <
          this.imgW * this.imgH
        );
      });
      //静态点击选中数据
      let clickDataT = this.canvasChangList.filter((el, index) => {
        let wb = this.cW / el.width;
        let hb = this.cH / el.height;
        return (
          Math.pow(x - el.x * wb, 2) + Math.pow(y - el.y * hb, 2) <
          this.imgW * this.imgH
        );
      });
      // 寻找第一个接近的数据点，动态优先
      if (
        (clickDataT && clickDataT.length) ||
        (clickData && clickData.length)
      ) {
        this.clickItem = clickData[0] || clickDataT[0];
        // console.log(this.clickItem);
        this.showGY = this.clickItem.alarmId ? true : false;
        // 点击的设备的ID--三目防止build未返回
        this.clickId =
          this.alarmDetail.buildingCode === null
            ? this.alarmDetail.alarmDevId
            : this.clickItem.deviceId ||
              this.clickItem.alarmDevId ||
              this.clickItem.parentDeviceId;
        // if (!this.clickId) {
        //   this.$message.warning("该设备已经不存在，暂无法查看")
        //   return
        // }
        // 绘制静态图标
        if (clickDataT.length) {
          this.clearCanvas("mycanvas2");
          this.canvasChangList.forEach((el) => {
            if (el.deviceId == this.clickId) {
              el.img = "yellow";
            } else {
              el.img = "blue";
            }
            let wb = this.cW / el.width;
            let hb = this.cH / el.height;
            this.daDrawImg(
              el.img,
              el.abscissa * wb,
              el.ordinate * hb,
              12.5,
              el,
              "mycanvas2"
            );
          });
        }
        this.getDeviceDetails(this.clickId);
      } else {
        // this.showDeviceTip = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.canvasTip {
  z-index: 2;
  position: absolute;
}

.fire-alarm-page {
  width: 100%;
  height: 100%;
  padding: 12px 12px 0 12px;

  .section-mian_left {
    width: 350px;
    margin-right: 12px;
    position: relative;
    background-color: rgba(11, 18, 35, 0.2);
    backdrop-filter: blur(5px);
    // position: absolute;
    // height: 100%;

    .ioc-alarm__list {
      top: 0;
      height: calc(100% - 0px) !important;

      .ioc-alarm__list__item {
        li {
          height: 100px;
        }
      }
    }
  }

  .section-mian_right {
    position: relative;

    // margin-bottom: 10px;
    .louceng-img {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .canvasMain {
      position: relative;
      background: rgba(128, 128, 128, 0.5);
      width: 100%;
      height: 100%;
      overflow: hidden;

      .canvasMainT {
        position: absolute;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }

        canvas {
          position: absolute;
        }

        #mycanvas {
          animation: fade 1s infinite;
          -webkit-animation: fade 1s infinite;
        }

        @keyframes fade {
          from {
            opacity: 1;
          }

          50% {
            opacity: 0.4;
          }

          to {
            opacity: 1;
          }
        }

        @-webkit-keyframes fade {
          from {
            opacity: 1;
          }

          50% {
            opacity: 0.4;
          }

          to {
            opacity: 1;
          }
        }
      }
    }

    .marTip {
      .restCanvas {
        &:hover {
          opacity: 0.8;
        }
      }

      div {
        position: absolute;
        right: 25px;
        bottom: 15px;
        color: #121722;
      }
    }

    .no-drawing {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: #fff;
      color: #ccc;
      font-size: 32px;
      display: flex;
      /*实现垂直居中*/
      align-items: center;
      /*实现水平居中*/
      justify-content: center;
      text-align: justify;
    }
  }
}

.popover {
  z-index: 10;

  .el-popover {
    @include set_theme_color(background-color, top-menu-bg-color);

    .pop-title {
      margin-bottom: 10px;
      @include set_theme_color(color, font-default-color);
      justify-content: space-between;

      .title-bar {
        font-size: 14px;
      }
    }

    .footer-btn {
      justify-content: center;

      button {
        margin-top: 12px;
        padding: 5px 13px;
      }
    }

    .grid-content {
      line-height: 30px;
      @include set_theme_color(color, font-default-color);
    }
  }
}
</style>
*{ margin: 0; padding: 0; } .head-btn{ text-align: center; margin-top: 50px; } .file {
position: relative; display: inline-block; background: #D0EEFF; border: 1px solid #99D3F5;
border-radius: 10px; padding: 24px 50px; overflow: hidden; color: #1E88C7;
text-decoration: none; text-indent: 0; line-height: 20px; font-size: 40px; } .file input {
position: absolute; font-size: 200px; right: 0; top: 0; opacity: 0; } .file:hover {
background: #AADFFD; border-color: #78C3F3; color: #004974; text-decoration: none; }
